module.exports = __webpack_public_path__ + "img/bg.7476c47c.jpg";